import {
	ChangeDetectorRef,
	Component,
Inject,	ElementRef,
	EventEmitter,

	Pipe,
	PipeTransform,
	ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';


import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {RestService} from "../immerdrin/rest.service.interface";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {OaseDeleteDialogComponent} from "../immerdrin/oase.delete.component";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {EintragInsertEditComponent} from "./eintrag.insertEdit.component";
import {Eintrag} from "./eintrag.model";
import { Datei } from "../datei/datei.model";
import {Image} from "@ks89/angular-modal-gallery";
import {Kategorie} from "../kategorie/kategorie.model";
import {APIConfigService} from "../../api.config.service";
import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http";
import {ErrorHelper} from "../../shared/error.helper";
import {MatCard, MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";

const PATH_FILE = 'app/protected/eintrag/eintrag.component.ts';
const OBJ_LNG_NAME = 'eintrag';
const BACKEND_PATH_PREFIX = 'eintrag';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/
// const REST_API_KATEGORIE = REST_API_BASE + 'kategorie/';

@Component({
    selector: 'oase-eintrag',
    templateUrl: './eintrag.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class EintragComponent extends Tabelle<Eintrag> {

	_selectsuche: string[] = new Array<string>();

	EintragTyp: number;
	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	ladedatenEintragn: boolean = true;
	  kategorieListe: Kategorie[] = Array<Kategorie>();

	maxSortierung: number = 1;


	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/eintrag",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "createDate",
				DEFAULT_SORT_START: 'desc',
				extraDataForAdding: { }
			}
		);

		this.displayedColumns = [
			'text', 'createDate',
			'ablaufdatum','admin',
		];

		this.title.setTitle(this.getTitle());

		this.breadcrumbService.addFriendlyNameForRoute('/protected/newseintraege', this.translation.translate('eintrag.typnews'));
		this.breadcrumbService.addFriendlyNameForRoute('/protected/dokumenteeintraege', this.translation.translate('eintrag.typdokumente'));
		this.breadcrumbService.addFriendlyNameForRoute('/protected/vertraegeeintraege', this.translation.translate('eintrag.typvertraege'));

		this.breadcrumbService.hideRouteRegex('protected/newseintraege/[0-9]');
		this.breadcrumbService.hideRouteRegex('protected/dokumenteeintraege/[0-9]');
		this.breadcrumbService.hideRouteRegex('protected/vertraegeeintraege/[0-9]');

      	this.EintragTyp=Number(route.snapshot.paramMap.get('kategorieTyp'));
      	this.getKategorien();
	}

	getTitle() {
		return this.translation.translate('eintrag.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		super.extraInit();
	}

	public afterDataIsLoaded() {
		if(this.dataSource.content.length>0)
			this.maxSortierung=this.dataSource.content.length;
	}

	createNewElement() {
		return new Eintrag();
	}

	loeschenSpalteName() {
		return "text";
	}

	getApiParams() {
		// this.setEintragData();
		this.EintragTyp=Number(this.route.snapshot.paramMap.get('kategorieTyp'));
		return "seite/"+this.EintragTyp;
	}


	vorHinzufuegen(element) {
		element.typ=this.EintragTyp;
		element.maxSortierung=this.maxSortierung;
		element.kategorieListe=this.kategorieListe;
	}

	zeigeLoeschenMaske(element: any) {
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(EintragInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {
		element.typ=this.EintragTyp;
		element.maxSortierung=this.maxSortierung;
		element.kategorieListe=this.kategorieListe;
    	element.ablaufdatum = new Date(element.ablaufdatum);
		this._zeigeBearbeitenMaske(element, EintragInsertEditComponent);
	}


  private getKategorien() {
    this._logger.log(PATH_FILE + ' - getKategorien Begin für Typ: '+this.EintragTyp);

    this.ladedatenEintragn = true;
    this.ladedaten = this.ladedatenEintragn;

    this.http
      .get<Kategorie[]>(this.apiConfigService.REST_API_BASE() + 'kategorie/liste/' + this.EintragTyp)
      //  // Um mehrfachaufrufe zu verhindern
      .subscribe(
      data => {
        // this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
        this.kategorieListe = data;
        this._logger.log(PATH_FILE + ' - getKategorien End');
        this.ladedatenEintragn = false;
        this.ladedaten = this.ladedatenEintragn;
      },
      err => {
        this.ladedatenEintragn = false;
        this.ladedaten = this.ladedatenEintragn;
        ErrorHelper.handleError(err, "Fehler beim holen der Kategorien", this._logger, this.translation)
      },
      () => {
        this.ladedatenEintragn = false;
        this.ladedaten = this.ladedatenEintragn;
        this._logger.log(PATH_FILE + ' - Holen der Kategorien abgeschlossen')
      }
      );
  } // getKategorien

  getDatei(Eintrag: Eintrag): Datei[] {
    return Eintrag.anhang;
  }

  openImagePopup(Eintrag: Eintrag) {
    let bild: Datei[] = this.getDatei(Eintrag);
    if(bild !== null) {
      let title = bild[0].name;
      // let image: Image = new Image(this.authService.getAuthUrl(bild[0].url + '/w2500'), null, title, null); // img, thumb, description, extUrl (https://ks89.github.io/angular-modal-gallery.github.io/features#Image)
      let image: Image = new Image(0, { img: this.authService.getAuthUrl(bild[0].url + '/w2500'), description: title });
	  // img, thumb, description, extUrl (https://ks89.github.io/angular-modal-gallery.github.io/features#Image)
      this.isImagePopupOpen = true;
      this.imagePopupImages = new Array<Image>();
      this.imagePopupImages.push(image);
      this.imagePopupPointer  = 0;
    }
  }

  closeImagePopup() {
    this.isImagePopupOpen = false;
    this.imagePopupImages = new Array<Image>();
    this.imagePopupPointer  = 0;
  }

}

